import * as React from 'react';
const SvgLine = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M15.425 1.475a2.955 2.955 0 0 0-2.95 2.95c0 .625.2 1.2.533 1.683l-6.825 6.825c-.458-.291-1-.475-1.591-.475a2.955 2.955 0 0 0-2.95 2.95 2.955 2.955 0 0 0 2.95 2.95 2.955 2.955 0 0 0 2.95-2.95c0-.591-.175-1.141-.475-1.6l6.858-6.858c.442.267.95.425 1.5.425a2.955 2.955 0 0 0 2.95-2.95 2.955 2.955 0 0 0-2.95-2.95M4.592 17.117c-.942 0-1.7-.767-1.7-1.7 0-.934.766-1.7 1.7-1.7s1.7.766 1.7 1.7-.767 1.7-1.7 1.7M15.425 6.133c-.942 0-1.7-.766-1.7-1.7s.767-1.7 1.7-1.7 1.7.767 1.7 1.7c0 .934-.767 1.7-1.7 1.7" />
  </svg>
);
export default SvgLine;
